const searchForms = document.querySelectorAll('.f-search');

searchForms.forEach(form => {
  const input = form.querySelector<HTMLElement>('.f-text input');
  const closeButton = form.querySelector<HTMLElement>('.f-search__close-button');

  closeButton?.addEventListener('click', () => {
    form.classList.remove('--open');
    document.body.classList.remove('--disable-scroll');
  })

  input?.addEventListener('focus', () => {
    form.classList.add('--open');
    if(input.closest('.main-header')) document.body.classList.add('--disable-scroll');
  })

  window.addEventListener('click', (e) => {
    const targetElement = e.target as HTMLElement;

    if (!form.contains(targetElement)) {
      form.classList.remove('--open')
      document.body.classList.remove('--disable-scroll');
    }
  })
})
